import { Trans } from '@lingui/react'
import { Paper } from '@material-ui/core'
import React, { FunctionComponent } from 'react'
import SignatureModel from '../Models/SignatureModel'

export interface SignatureProps {
  data: SignatureModel
}

const Signature: FunctionComponent<SignatureProps> = ({ data }) => {
  return (
    <Paper elevation={0} variant='outlined' style={{ padding: '20px', margin: '10px 0 10px 0' }}>
      <div id='signatureDiv' style={{ fontSize: 'small' }}>
        <strong>
          <Trans id='' message='Número de Cita: ' />
        </strong>
        &nbsp; <span>{data.appointmentId}</span>
        <br />
        <strong>
          <Trans id='' message='Nombre de paciente: ' />
        </strong>
        <span>{data.patientName}</span>
        <br />
        <strong>
          <Trans id='' message='Nombre de quien asiste: ' />
        </strong>
        <span>{data.asistingPersonName}</span>&nbsp;&nbsp;
        <strong>
          <Trans id='' message='No. de Documento: ' />
        </strong>
        <span>{data.patientId}</span>
        <br />
        <strong>
          <Trans id='Entidad: ' message='Entidad: ' />
        </strong>
        <span>{data.locationName}</span>
        <br />
        <strong>
          <Trans id='' message='Examen: ' />
        </strong>
        <span>{data.examName}</span>&nbsp;&nbsp;
        <strong>
          <Trans id='' message='Nombre del especialista: ' />
        </strong>
        <span>{data.specialistName}</span>
        <br />
        <strong>
          <Trans id='' message='Fecha: ' />
        </strong>
        <span>{data.appointmentDate}</span>
        <br />
        <strong>
          <Trans id='' message='Validación de documentos' />
        </strong>
        <p style={{ overflowWrap: 'break-word', margin: 0 }}>{data.JWT}</p>
      </div>
    </Paper>
  )
}

export default Signature
